module.exports = __webpack_public_path__ + "static/media/media_bg.203fcd2b.png";